import { replace } from 'lodash';

export function getGraphQLPlatform(platformStr) {
  return replace(platformStr, 'ios', 'iOS');
}

export function getRestPlatform(platformStr) {
  return platformStr.toLowerCase();
}
